import { useNavigate } from "react-router-dom";
import GuidelinesGrid from "../shared/GuidelinesGrid";
import { AppLayout, AppSidebar, AppHeader, MainContent } from "../Layout";

const GuidelinesPage = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    // Navigate back to the previous page or home
    navigate(-1);
  };

  return (
    <AppLayout appSidebar={<AppSidebar />} appHeader={<AppHeader />} useMainContentWrapper={true}>
      <MainContent padding="none">
        <GuidelinesGrid variant="page" showCloseButton={true} onClose={handleClose} />
      </MainContent>
    </AppLayout>
  );
};

export default GuidelinesPage;
